import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NetWorthTrendWidgetComponent } from '../net-worth-trend-widget/net-worth-trend-widget';
import { CashFlowPreviewWidgetComponent } from '../cash-flow-preview-widget/cash-flow-preview-widget';
import { SavingsGoal } from '../savings-goal/savings-goal';
import { SpendingSnapshotWidgetComponent } from '../spending-snapshot-widget/spending-snapshot-widget';
import { AiAdviceWidgetComponent } from '../ai-advice-widget/ai-advice-widget';
import { AiChatWidgetComponent } from '../ai-chat-widget/ai-chat-widget';
import { DebtsSummaryWidgetComponent } from '../debts-summary-widget/debts-summary-widget';
import { UpcomingBills } from '../upcoming-bills/upcoming-bills';
import { InvestmentOverviewWidgetComponent } from '../investment-overview-widget/investment-overview-widget';
import { AccountSummary } from '../account-summary/account-summary';
import { BudgetStatus } from '../budget-status/budget-status';
import { ExpenseTotalWidgetComponent } from '../expense-total-widget/expense-total-widget';
import { LoanOffersWidgetComponent } from '../loan-offers-widget/loan-offers-widget';
import { InsuranceOffers } from '../insurance-offers/insurance-offers';
import { ExpenseTracker } from '../expense-tracker/expense-tracker';
import { MyCards } from '../my-cards/my-cards';
import { DealsOffers } from '../deals-offers/deals-offers';
import { CardOffersWidget } from '../card-offers/card-offers';
import { TotalBalanceWidget } from '../total-balance/total-balance';
import { TodaysExpenseTotalComponent } from '../todays-expense-total/todays-expense-total';
import { LifetimeExpense } from '../lifetime-expense/lifetime-expense';
import { EnergyExpense } from '../energy-expense/energy-expense';
import { Loans } from '../loans/loans';
import { InvestmentValue } from '../investment-value/investment-value';


@Component({
  selector: 'app-widgets-right-drawer',
  standalone: true,
  imports: [
    CommonModule,
    NetWorthTrendWidgetComponent,
    CashFlowPreviewWidgetComponent,
    SavingsGoal,
    SpendingSnapshotWidgetComponent,
    AiAdviceWidgetComponent,
    AiChatWidgetComponent,
    DebtsSummaryWidgetComponent,
    UpcomingBills,
    InvestmentOverviewWidgetComponent,
    AccountSummary,
    BudgetStatus,
    ExpenseTotalWidgetComponent,
    LoanOffersWidgetComponent,
    InsuranceOffers,
    ExpenseTracker,
    MyCards,
    DealsOffers,
    CardOffersWidget,
    TotalBalanceWidget,
    TodaysExpenseTotalComponent,
    LifetimeExpense,
    EnergyExpense,
    Loans,
    InvestmentValue
  ],

  templateUrl: './widgets-right-drawer.html',
  styleUrl: './widgets-right-drawer.scss',
})
export class WidgetsRightDrawer {
  @Input() activeWidgets: any[] = [];

  readonly ALL_WIDGET_TYPES = [
    'networthtrend', 'cashflowpreview', 'savings', 'spending',
    'aiadvice', 'aichat', 'debts', 'bills', 'budget',
    'expensetotal', 'investmentoverview', 'expensetracker',
    'balance', 'todayexpensetotal', 'lifetimeexpense', 'energyexpense',
    'mycards', 'accountsummary', 'dealsoffers', 'loanoffers',
    'cardoffers', 'insurance', 'loans', 'investmentvalue'
  ];

  isAddMode = true;
  @Output() close = new EventEmitter<void>();
  @Output() toggleEdit = new EventEmitter<void>();
  @Output() addWidgetRequest = new EventEmitter<string>();

  onClose() {
    this.close.emit();
  }

  onToggleEdit() {
    this.toggleEdit.emit();
  }

  onAddWidget(type: string) {
    this.addWidgetRequest.emit(type);
  }

  isWidgetActive(type: string): boolean {
    return this.activeWidgets.some(w => w.type === type);
  }

  get isAllWidgetsActive(): boolean {
    return this.ALL_WIDGET_TYPES.every(type => this.isWidgetActive(type));
  }
}
